import type { PortableTextMarkComponentProps } from '@portabletext/react';
import type { TypedObject } from '@portabletext/types';
import type { ReactNode } from 'react';

export type TextClassName =
    | 'display-1'
    | 'display-2'
    | 'display-3'
    | 'display-4'
    | 'heading-1'
    | 'heading-2'
    | 'heading-3'
    | 'heading-4'
    | 'heading-5'
    | 'heading-6'
    | 'text-xl'
    | 'text-lg'
    | 'text-md'
    | 'text-sm'
    | 'text-primary-500'
    | 'text-gray-900'
    | 'text-white';

export type ClassNameValue = TypedObject & {
    _type: 'className';
    // Array since the multi-select migration; legacy content may still hold a single string.
    value?: TextClassName | TextClassName[];
};

export function ClassNameWrapper({ value, children }: { value?: ClassNameValue; children: ReactNode }) {
    const classNames = Array.isArray(value?.value) ? value.value : value?.value ? [value.value] : [];
    return <span className={classNames.join(' ')}>{children}</span>;
}

export const classNameMark = ({ value, children }: PortableTextMarkComponentProps<ClassNameValue>) => {
    return <ClassNameWrapper value={value}>{children}</ClassNameWrapper>;
};
